"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_a7f267bc{position:relative;padding:10px 84px;cursor:pointer}.root_a7f267bc .ms-Link{font-size:12px}\n" }]);
exports.root = "root_a7f267bc";
//# sourceMappingURL=GroupShowAll.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/GroupedList/GroupShowAll.scss.js
// module id = 1565
// module chunks = 0